import { renderButton_unstable } from "@fluentui/react-components";
import type { AppPaddleButtonState } from "./AppPaddleButton.types";

export const renderAppPaddleButton = (state: AppPaddleButtonState) => {
  return renderButton_unstable(state);
};
